<template>
  <div class="container login-success">
    <submit-header
      :headerConfig="headerConfig"
      @handleClickIocn="handleClickIocn"
    />
    <div class="main">
      <div class="tip-wrap">
        <success-tip :infoStyle="infoStyle" :info="info" />
      </div>

      <div>
        <el-button @click="handlePay" v-show="canpay && this.checkStatus == '已完成'"
          >立即缴费</el-button
        >
        <el-button @click="getSignUpInfo">查看报名信息</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import submitHeader from "@/components/header"
  import successTip from "@/components/successTip"
  import store from "@/store"

  import CurrentConferMixin from "@/mixin/CurrentConference"
  import CurrentUserMixin from "@/mixin/CurrentUser"
  import { Signup } from "@/store/entity/signup"
  export default {
    name: "submitType",
    components: {
      submitHeader,
      successTip,
    },
    mixins: [CurrentConferMixin, CurrentUserMixin],
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-cuowu",
          headerTitle: "中国土木工程学会",
          color: "",
        },
        infoStyle: {
          color: "#f9000d",
        },
        isNeedExamine: true,
        attendidentityArr: [],
        checkStatus: "",
      }
    },

    computed: {
      info() {
        //console.log("this.currentSignup.attendid");
        //console.log(this.currentSignup.attendid.code);
        //return this.isNeedExamine ? "您的报名信息已提交请等待审核!" : "报名成功, 请尽快缴费"
        console.log("this.checkStatus")
        console.log(this.checkStatus)
        return this.checkStatus != "已完成"
          ? "您的报名信息已提交请等待审核!"
          : "报名成功, 请尽快缴费"
      },
      canpay(){
        let d1 =new Date().getTime()
        let d2 = new Date(this.currentConference.paydeadline).getTime()
        if(d1>=d2){
          return false;
        }else{
          return true;
        }
      }
    },

    created() {
      this.getSignupList()
    },
    methods: {
      handleClickIocn() {
        //do something
        //this.$router.go(-1)
        this.$router.push("/info")
      },

      /* 立即缴费 */
      handlePay() {
        this.$router.push({ name: "pay" })
      },

      /* 报名信息 */
      getSignUpInfo() {
        this.$router.push("/info")
      },
      getSignupList() {

        let ids = {}
        console.log("getSignupList"+this.currentUser)
        console.log("getSignupList"+this.currentSignup)
        ids = Signup.getSignupList({
          per_page: -1,
          page: -1,
          conference_id: this.currentConference.id,
          created_by_id: this.currentUser.id,
          order_by_desc: "create_time",
          deleted:false
        }).then((data) => {
          data.signup_list.forEach((x) => {
            this.attendidentityArr.push({ id: x.id, status: x.status })
            this.checkStatus = x.status
          })
          //this.rules["name"][0]["required"] = false;
        })
        console.log(this.attendidentityArr)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    text-align: center;

    ::v-deep .el-button {
      position: relative;
      top: 150px;
      width: 80%;
      margin: 0 auto 15px;
      background: var(--main-color);
      color: #fff;

      &:hover {
        color: #fff;
      }

      &:focus {
        background: var(--main-color);
        border-color: #fff;
      }
    }
  }
</style>
